module.exports = __webpack_public_path__ + "static/media/riskstep2.5f4cfdac.svg";